










import { Vue, Component, Provide, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class FilterDropdownComponent extends Vue {
  @Prop() readonly items!: any;

  @Provide()
  selectedValue = "All";

  onChange() {
    this.$emit("search", this.selectedValue);
  }
}
